import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { formatDecimal } from '@/utils/formatNumber';
import type { Project } from '@/api/client';

interface AuthorSheetsCellProps {
  project: Project;
}

export const AuthorSheetsCell = memo(function AuthorSheetsCell({ project }: AuthorSheetsCellProps) {
  const value = project.author_sheets;

  const display = value != null ? (
    <div className="projects-table__author-sheets-cell">
      <span className="projects-table__author-sheets-label">АЛ:</span>
      <span className="projects-table__author-sheets-value">
        <strong>{formatDecimal(value)}</strong>
      </span>
    </div>
  ) : null;

  return (
    <EditableCell project={project} fieldKey="author_sheets">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
